export default __webpack_public_path__ + "static/media/bids_logo.da6759c3.png";